export default __webpack_public_path__ + "static/media/icon-stamp.af9476bf.svg";